/* RP - Responsable de proceso -  toma decisión de la(s) propuesta(s) asignadas a su rol */

//*react- recursos
  import { useState, useEffect} from "react";
  import { Panel, PanelGroup } from "rsuite";
  import ReactPaginate from "react-paginate";

//*componentes-utiles
  import CargandoSpin from "../../../../componentes/CargandoSpin";

//*clases 

//*imágenes
  import { AiOutlineDoubleLeft, AiOutlineDoubleRight } from "react-icons/ai";

//*archivo & componentes (otros componentes enlazados)
  import RPContenido from "./RP.Contenido"; 

//*api's (servicios y store)
  import decisionsServicio from "../../../../api/recursos/decisions/decisions.servicio"; 
  import decisionsStore from "../../../../api/recursos/decisions/decisions.store"; 

  import catalogsServicio from "../../../../api/recursos/catalogs/catalogs.servicio"; 
  import catalogsStore from "../../../../api/recursos/catalogs/catalogs.store"; 

  import ptCatalogsServicio from "../../../../api/recursos/ptCatalogs/ptCatalogs.servicio"; 
  import ptCatalogsStore from "../../../../api/recursos/ptCatalogs/ptCatalogs.store"; 

//*store's

//*datos
  import etiquetasSSC from "../../../../datos/json/etiquetasSSC.json"

//*funciones

//*interface
  interface propsRP {
    tokenStore: any;
    menuStore: any;
    quitaErrorPagina:any;
    recargaPaginaSSC:any;
    recargaPaginaSSC_Not:any;
  }  

//*componente
  export default function RP(props: propsRP){

    //*api store
      const { guardaGetAllDecisionStore, catDecisionesStore,
              guardaGetAllQualityStore, catPrincipiosStore,
              guardaGetAllCyclesStore, 
              generaObjErrorCatalogsStore } =  
          catalogsStore((state:any) =>( { 
              guardaGetAllDecisionStore: state.guardaGetAllDecisionStore,
              catDecisionesStore: state.catDecisionesStore,
              guardaGetAllQualityStore: state.guardaGetAllQualityStore,
              catPrincipiosStore: state.catPrincipiosStore,
              guardaGetAllCyclesStore: state.guardaGetAllCyclesStore,
              generaObjErrorCatalogsStore: state.generaObjErrorCatalogsStore
      }));

      const { guardaGetAllEvidenceStore, catPTEvidenciasStore,
              guardaPTGetAllCyclesStore, 
              combinaCatalogosCiclosStore,
              generaObjErrorPtCatalogsStore } =  
          ptCatalogsStore((state:any) =>( { 
              guardaGetAllEvidenceStore: state.guardaGetAllEvidenceStore,
              catPTEvidenciasStore: state.catPTEvidenciasStore,
              guardaPTGetAllCyclesStore: state.guardaPTGetAllCyclesStore,
              combinaCatalogosCiclosStore: state.combinaCatalogosCiclosStore,
              generaObjErrorPtCatalogsStore: state.generaObjErrorPtCatalogsStore
      }));
        
      const { guardaGetSummaryPxFStore, pxfStore,
              guardaGetDetailbyProcessStore,
              cambiapxfStore,
              actualizaCiclosStore,
              generaObjErrorDecisionsStore } =  
          decisionsStore((state:any) =>( { 
              guardaGetSummaryPxFStore: state.guardaGetSummaryPxFStore,
              pxfStore: state.pxfStore,
              guardaGetDetailbyProcessStore: state.guardaGetDetailbyProcessStore,
              cambiapxfStore: state.cambiapxfStore,
              actualizaCiclosStore: state.actualizaCiclosStore,
              generaObjErrorDecisionsStore: state.generaObjErrorDecisionsStore
      }));

    //*store's
    
    //*datos
      var _ = require('underscore');

    //*constantes y variables
      let eti = etiquetasSSC.RP;
      let x0, x1, x1a, x2, x3 = '';
      let otroAnios = [];
      //paginación: constante para el manejo de la 
        const data  = pxfStore;  //data es quien se muestra para que generé la paginación
        const [currentItems, setCurrentItems] = useState([]);  //elementos mostrados según páginación
        const [pageCount, setPageCount] = useState(0);  //contabilidad de la página
        const [itemOffset, setItemOffset] = useState(0);  //desplazamiento 
        const itemsPerPage = 10;   //número de elementos a mostrar
  
    //*useState
      const [swRecarga, setSwRecarga] =  useState(false);
      const [swRecargaRP, setSwRecargaRP] =  useState(false); //usado para remasterizar esta página
      const [cargandoSpin,setCargandoSpin] = useState(false);

      const [propuestasxFrecuencia, setPropuestasxFrecuencia] = useState({});// lo uso para renderizar dentro de un useEffect, no lo uso en la página

      const [pxfId, setPxfId] = useState(0);

      const [swRecargaCiclos, setSwRecargaCiclos] = useState(false);
      const [swRecargaPxF, setSwRecargaPxF] = useState(true);
      const [swPxF, setSwPxF] = useState(false); 
      
    //*useEffect

      useEffect(()=> { // al montar
        console.log('RP - monto')
        props.quitaErrorPagina();
        //console.clear();
      },[]);

      useEffect(()=> { //Carga cátalogo "Decisiones"- llama API - Catalogs/GetAllDecision
        setCargandoSpin(true); 
        catalogsServicio.cargaGetAllDecision(props.tokenStore)
          .then((response:any) => {
            if (response.status==200){  //revisa si hay error
                guardaGetAllDecisionStore(response.data).then( function(catDecisionesFront:any) { 
                  //console.log('Cargo información de api en CatDecisionesStore');
                })
            }
            setCargandoSpin(false);   
          })
          .catch((ex) => { 
              console.log ("--catch - ex (GetAllDecision): ", ex);
              generaObjErrorCatalogsStore(ex.response, true, '', '', 'RP-Catalogs/GetAllDecision','RP');
              setCargandoSpin(false);   
              recargaPaginaSSC();
          })
      },[]);
      
      useEffect(()=> { //Carga cátalogo "Principios de calidad"- llama API - Catalogs/GetAllQuality
        setCargandoSpin(true);   
        catalogsServicio.cargaGetAllQuality(props.tokenStore)
          .then((response:any) => {
            if (response.status==200){  //revisa si hay error
                guardaGetAllQualityStore(response.data).then( function(catPrincipiosFront:any) { 
                  //console.log('Carga información del api a CatPrincipiosStore');
                })
            }
            setCargandoSpin(false);    
          })
          .catch((ex) => { 
              console.log ("--catch - ex (cargaGetAllQuality): ", ex);
              generaObjErrorCatalogsStore(ex.response, true, '', '', 'RP-Catalogs/GetAllQuality','RP');
              setCargandoSpin(false); 
              recargaPaginaSSC();  
          })
      },[]);
      
      useEffect(()=> { //Carga cátalogo "Evidencias"- llama API - Catalogs/GetAllEvidence 
        setCargandoSpin(true);   
        ptCatalogsServicio.cargaGetAllEvidence(props.tokenStore)
          .then((response:any) => {
            if (response.status==200) {  //revisa si hay error
                  guardaGetAllEvidenceStore(response.data).then( function(catPTEvidenciasFront:any) { 
                  //console.log('Cargo información del api en catPTEvidenciasStore' );
                })
            }  
            setCargandoSpin(false);       
          })
          .catch((ex) => { 
              console.log ("--catch - ex (GetAllCycles): ", ex);
              generaObjErrorPtCatalogsStore(ex.response, true, '', '', 'RP-PtCatalogs/GetAllEvidence','RP');
              setCargandoSpin(false);  
              recargaPaginaSSC(); 
          })
      },[]);

      //Carga dos cátalogos de  "Ciclos" - llama API - PtCatalogs/GetAllCycles
      //Carga dos cátalogos de  "Ciclos" - llama API - Catalogs/GetAllCycles  - combina los dos catálogos
      //Carga "ProcesoxFrecuencia" - llama API -  Decisions/GetSummaryPxF - agrega los ciclos que le corresponden al proceso
      useEffect(()=> { 
        //*Carga cátalogo "Ciclos"- llama API - PtCatalogs/GetAllCycles
        setCargandoSpin(true);
        ptCatalogsServicio.cargaGetAllCycles(props.tokenStore)
          .then((response:any) => {
              if (response.status==200) {  //revisa si hay error
                    guardaPTGetAllCyclesStore(response.data).then( function(catPTCiclosFront:any) { 
                    //console.log('carga información del api en catPTCiclosStore');
                   
          //*Carga cátalogo "Ciclos"- llama API - Catalogs/GetAllCycles
                    setCargandoSpin(true);
                    catalogsServicio.cargaGetAllCycles(props.tokenStore)
                      .then((response:any) => {
                        if (response.status==200) {  //revisa si hay error
                            guardaGetAllCyclesStore(response.data).then( function(catCiclosFront:any) { 
                              //console.log('carga información del api en catCiclosStore' );
                              //*llamo funcion store de ptCatalogs para combinar los ciclos, el combinado queda en: catPTCiclosStore
                              combinaCatalogosCiclosStore(catCiclosFront).then( function(catPTCiclosFront:any) { 
                              //console.log('**catPTCiclosStore: ', catPTCiclosStore );
                                  
          //*Cargo ProcesosxFrecuencia -llama API -  Decisions/GetSummaryPxF
                                if (swRecargaPxF) { //valor inicial
                                    setCargandoSpin(true);
                                    decisionsServicio.cargaGetSummaryPxF(props.tokenStore)
                                      .then(function(response:any){
                                          if (response.status==200){  //revisa si hay error
                                              guardaGetSummaryPxFStore(response.data, catPTCiclosFront ).then( function(datos:any) { 
                                                //console.log('carga información de api en pxfStore' );
                                                setSwRecargaPxF(false);
                                              })
                                              setCargandoSpin(false);    
                                          }
                                      })
                                      .catch((ex) => {
                                          console.log ("--catch - ex (cargaGetSummarybyUser): ", ex.response.status);
                                          if (ex.response.status==404) //no es error solo no tiene información
                                            console.log('nota: no es error solo no tiene información')
                                          else
                                            generaObjErrorDecisionsStore(ex.response, true, '', '', 'RP-Decisions/GetSummaryPxF','RP')
                                          setCargandoSpin(false);   
                                          recargaPaginaSSC(); 
                                      })
                                }
                                else { //ya se leyo una vez, solo se actualiza en pxfStore el ciclo porque se agrego uno nuevo
                                  actualizaCiclosStore(pxfId, catPTCiclosFront)
                                }    
                              })
                            })
                            setCargandoSpin(false);    
                        }
                      })
                      .catch((ex) => { 
                          console.log ("--catch - ex (GetAllCycles): ", ex);
                          generaObjErrorCatalogsStore(ex.response, true, '', '', 'RP-catalogs/GetAllCycles','RP');
                          setCargandoSpin(false);
                          recargaPaginaSSC(); 
                      })
                    //*    
                  })
              }
              setCargandoSpin(false);    
          })
          .catch((ex) => { 
              console.log ("--catch - ex (GetAllCycles): ", ex);
              generaObjErrorPtCatalogsStore(ex.response, true, '', '', 'RP-PtCatalogs/GetAllCycles','RP');
              setCargandoSpin(false);  
              recargaPaginaSSC(); 
          })
          setCargandoSpin(false);    
      },[swRecargaCiclos]);

      useEffect(()=> { // usado para los otros ciclos en un select
        otroAnios.push("Seleccionar");
        let i=0;
        for(i=2000; i<2051; i++) {
          otroAnios.push(i.toString());
        }
      },[]);

      useEffect(()=> { // uso este puente para recargar elementos del front, no uso ese useState
        console.log('RD - rederizando............');
        setCargandoSpin(false);
        setPropuestasxFrecuencia(pxfStore);
        setSwRecargaRP(!swRecargaRP);
      },[swRecarga]);

      //páginación: se ejectura al cambio de un elementos (al click en los botones)
        useEffect(() => { 
          console.log('entro a useEffect paginación')
          const endOffset = itemOffset + itemsPerPage;
          setCurrentItems(data.slice(itemOffset, endOffset));
          setPageCount(Math.ceil(data.length / itemsPerPage));
          setSwRecarga(!swRecarga);
          console.log('::data', data);
        }, [itemOffset, itemsPerPage, data]);
        
        useEffect(()=>{ window.scrollTo({top:0});  },[currentItems]); //para páginación
    
  
    //*funciones

      const recargaPaginaSSC = () => { props.recargaPaginaSSC() } //ejecuta la función que esta en Contenido que llama a la renderización de PaginaSSC

      const recargaPaginaSSC_Not = () => { props.recargaPaginaSSC_Not() } //ejecuta la función que esta en Contenido que llama de PaginaSSC recargar el api de notificaciones para la campana

      const recargaRP = () => {  // con esto ejecuto un useEffect, lo uso para renderizar el front 
            setSwRecarga(!swRecarga);
      }

      const recargaCiclosStore = (id:any) => {
        //alert('recargaCiclosStore desde RP');
        setSwRecargaCiclos(!swRecargaCiclos); // con esto ejecuto un useEffect, lo uso para renderizar el front y actualice los ciclos
      }

      const abreCierraPxF = (pxf:any) => {  // abre y cierra el div de la propuesta
        //alert('abreCierraPxF...' + p.id + '...' + p.abierto)
        //console.clear();
        console.log('pxf:',pxf);
        setPxfId(pxf.id);
        if (pxf.abierto == false) { //esta cerrado y quiere abrir
            console.log('pxf.misPropuestas.length', pxf.misPropuestas.length)
            if (pxf.misPropuestas.length == 0) { //si tenemos propuestas ya cargo una vez solo abrimos, sino cargamos los detalles del procesoxfrecuencia
                setCargandoSpin(true);
                decisionsServicio.cargaGetDetailbyProcess(props.tokenStore, pxf.id) //p.id del processoxFrecuencia
                  .then((response:any) => {
                    if (response.status==200) {  //confirma que no hay error
                        guardaGetDetailbyProcessStore(response.data, pxf.id).then( function(pxfPropuestasFront:any) { 
                            setSwPxF(!swPxF);
                            //const data  = datos; nooooo data de paginación debe tener propuestasFrontStore no los detalles
                        })
                    } 
                    setCargandoSpin(false);
                  })
                  .catch((ex) => {
                      console.log ("--catch - ex (cargaGetDetailbyUser): ", ex.response.status);
                      if (ex.response.status==404) //no es error solo no tiene información
                          console.log('nota: no es error solo no tiene información')
                      else
                          generaObjErrorDecisionsStore(ex.response, true, '', '', 'RP-Decisions/GetDetailbyProcess','RP')
                      setCargandoSpin(false);
                      recargaPaginaSSC();
                  })
            }
            else { cambiapxfStore(pxf.id, null, true, null, 'abreCierraPxF') }
        }
        else { //esta abierto quiere cerrar, por lo tanto se ejecuta funcion de store que cambia abierto a false sin cambiar detalle
          //idpxf:any, idprop: any, abierto:any, detalle:any, dondeViene:any 
          cambiapxfStore(pxf.id, null, false, null, 'abreCierraPxF');
          setCargandoSpin(false);  
          
        };
        setSwRecarga(!swRecarga)
      }

      const clickPaginacion = (event: any) => {  //paginación: se ejecuta cuando se da un click en los elementos de páginación (botones)
        const newOffset = (event.selected * itemsPerPage) % data.length;
        //console.log("newOffset--------", newOffset);
        setItemOffset(newOffset);
        setSwRecarga(!swRecarga) 
      };

    //*vista
      return(
      <>

        {/* nota de mensaje de error */}
          { (props.menuStore[1].errorPagina==true) &&
              (<> <label className='color-red'>Nota: se detecto un error al leer un recurso API, ¡algunos componentes pueden no funcionar correctamente!</label><br/><br/> </>)
          }

        {/*titulo Proceso / Frecuencia */}
          <h5>Proceso / Frecuencia</h5>
        

        {/* div's - Procesos x Frecuencia con sus respectivas propuestas, utilizamos el cargaSpin porque es lento y la da efecto de carga */}       
          <div>
            {/* {console.log('pxfStore::::',pxfStore)} 
                {console.log('currentItems::::',currentItems)}       */}

            {/*  currentItems trae pxfStore se usa ésta para la paginación */ }    
            { currentItems?.map((pxf:any, index:any) => (
              (x0 =  `<span id='nvaprop'>  ${pxf.inprocess} ${eti.etiquetas[2].text} </span>&nbsp;
                      <span id='turnadaRP'>${pxf.accepted}  ${eti.etiquetas[3].text} </span>&nbsp;&nbsp;`),
            
              /*x2 forma el contendio del header del panel*/
              (x2 = 
                (<>
                  <div id={`divpanel_${pxf.id}`}>
                    {/* acrónimo/frecuencia & nombre del proceso & estatus */}
                    <span id="panelDes">
                      <span className='h3 color-secundario'> {pxf.pxfNombre} </span>
                      <span className="circulo pt-1 h5">  {pxf.totalPropuestas}</span>&nbsp;
                      <span className="circuloText h5"> {eti.etiquetas[1].text}</span>
                      <br />
                      <span className='h6'>{pxf.processname} </span> &nbsp;
                      <span className={pxf.clasexEstatusIcono}>{pxf.estatusProceso}</span>
                      <br />
                    </span>
                    
                    {/* # nuevas propuestas & # turnadas a rp */}
                    <span dangerouslySetInnerHTML={{ __html: x0, }} ></span>
                  </div>
                </>)
              ),
              (<>
                  <hr />
                  <PanelGroup accordion  >
                    <Panel
                      header={x2}
                      /* eventKey={index} usado cuando se quiere un solo panel abierto */
                      key={pxf.key}
                      id={pxf.id}
                      collapsible={pxf.abierto}
                      onClick={() => abreCierraPxF(pxf)}
                    >
                    </Panel>
                    {pxf.abierto
                      && <RPContenido
                            key={pxf.id}
                            tokenStore={props.tokenStore}
                            pxfId = {pxf.id}
                            misPropuestas={pxf.misPropuestas} 
                            misCiclos = {pxf.misCiclos}
                            catDecisionesStore = {catDecisionesStore}
                            catPrincipiosStore = {catPrincipiosStore}
                            catPTEvidenciasStore = {catPTEvidenciasStore}
                            recargaCiclosStore = {recargaCiclosStore}
                            recargaRP = {recargaRP}
                            recargaPaginaSSC = {recargaPaginaSSC}
                            recargaPaginaSSC_Not  = {recargaPaginaSSC_Not}
                          /> 
                    }
                  </PanelGroup> 
                </>)
            ))}                 
          </div>

        <hr/> <br/>

        {/* paginación: elemento visuales  */}
          {  pageCount > 1 &&
            (<>
                <ReactPaginate
                  //2.1
                  breakClassName="..."
                  nextLabel={
                  <AiOutlineDoubleRight style={{ fontSize: 18, width: 150, verticalAlign: "middle", marginLeft: "-10px",}} /> }          
                  pageRangeDisplayed={2}
                  pageCount={pageCount}
                  previousLabel={
                    <AiOutlineDoubleLeft style={{ fontSize: 18, width: 150, verticalAlign: "middle",  marginLeft: "10px", }} /> }
                  renderOnZeroPageCount={null}
                  containerClassName="pagination"
                  pageLinkClassName="page-num"
                  previousLinkClassName="page-num"
                  nextLinkClassName="page-num"
                  activeClassName="active"
                  disabledLinkClassName="gray"
                  onPageChange={clickPaginacion}
                  // onClick={clickPaginacion}
                />
              </>
            ) 
          }
      
        {/* ventana de carga con spin que se abre mientras lee el api */}
           { cargandoSpin && <CargandoSpin /> }

      </>
      )
  }
